import { Component } from '@angular/core';
import { DataService } from './services/data.service';
import { first } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.css'
})
export class AppComponent {
    title = '';

    modelos:any[]=[];
  
    constructor(private vehiculosService: DataService){
        localStorage.removeItem('motos');
        localStorage.removeItem('linea-de-fuerza');
      
    }

    ngOnInit(): void {
      this.cargarDatos('motos');
      this.cargarDatos('linea-de-fuerza');
    }

    private cargarDatos(tipo: string): void {
      const key = tipo === 'linea-de-fuerza' ? 'linea-de-fuerza' : 'motos';
      const guardados = localStorage.getItem(key);

      if (guardados) {
        this.modelos = JSON.parse(guardados);
      } else {
        const parametro = tipo === 'linea-de-fuerza' ? 'linea%20de%20fuerza' : 'motos';
        this.vehiculosService.getCategoriasModels(parametro).pipe(first()).subscribe(
          (data: any) => {
            this.modelos = data;
            localStorage.setItem(key, JSON.stringify(data));
          },
          (error: any) => {
            console.error('Error al cargar datos de', tipo, error);
          }
        );
      }
    }
}
